<ion-list *ngIf="isLoading || matches.length > 0; else noContent">
    <app-tie-match-scoreboard *ngFor="let match of matches" [match]="match"></app-tie-match-scoreboard>
</ion-list>

<ng-template #noContent>
    <app-empty-page text="{{'This player does not have any matches.' | translate}}" iconName="tennisball"></app-empty-page>
  </ng-template>